import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, ViewChild} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications

import { JobTypeDocument } from '../../../shared/models/jobTypeDocument.model';
import { DateFormat } from 'node_modules/@syncfusion/ej2-base/intl';
import { HotToastService } from '@ngneat/hot-toast';
import { BsModalService } from 'ngx-bootstrap/modal';
import { JobTypeAffidavit } from '../../../shared/models/jobTypeAffidavit.model';

// import { JobServiceRule } from '../../../shared/models/jobServiceRule.model';
import { JobServiceTimeframe } from './../../../shared/models/jobServiceTimeframe.model';
import { VariableCodeBlock } from 'src/app/shared/models/variableCodeBlockModel.model';
import { AppRoute } from 'src/app/shared/models/appRoute.model';
import { EditorManager, FileManagerService, HtmlEditorService, ImageService, InsertHtml, LinkService, QuickToolbarSettingsModel, RichTextEditorComponent, TableService, ToolbarService } from '@syncfusion/ej2-angular-richtexteditor';
import { DropDownList, DropDownListComponent } from '@syncfusion/ej2-angular-dropdowns';

import { WooPromotionVariableModalComponent } from '../../system-variables/woo-promotion-variable-modal/woo-promotion-variable-modal.component';
import { DataManager, DataUtil, Predicate, Query } from '@syncfusion/ej2-data';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
@Component({
  selector: 'app-app-route-create-widget',
  templateUrl: './app-route-create-widget.component.html',
  styleUrls: ['./app-route-create-widget.component.scss'],
  providers: [Location, {provide: LocationStrategy, useClass: PathLocationStrategy}, ToolbarService, LinkService, ImageService, HtmlEditorService, TableService, FileManagerService,],
})
export class AppRouteCreateWidgetComponent implements OnInit {
  @ViewChild('brandForm') form: any; // the name of the form to access.
  @Input('brandForm') brandForm: any;

  search_model: AppRoute;

  // model: JobServiceTimeframe;
  model: AppRoute; 
  job_types: any;
  job_type_locations: any;
  count2: any;
  get_latest_court_id: any;
  job_type_courts: any;

  @Input() send_job_type_location_id: any;
  @Input() send_job_type_court_id: any;
  @Input() send_job_type_id: any;
  @Input() send_job_type_document_type_id: any;


   // setup as observable?
   @Input() item_id?; // impliments on changes.
   @Input() item_data?; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size?; // side | abstract | full
  @Input() current_field_name?;

  @Input() is_modal?; // shows_hides modeal header if true shows.

  @Input() promotion_id: number;
  @Input() current_route: any;


  get_latest_affidavit_id: any;
    get_latest_document_id: any;
  job_type_document_types: any;
  
  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  sent_job_type_court_id: any;
  sent_job_type_location_id: any;
  get_latest_service_rule_id: any;
  get_latest_service_timeframe_id: any;
  job_service_timeframe_count_types: any;
  job_service_timeframe_time_types: any;
  job_service_timeframe_time_when: any;
  job_service_timeframe_date_types: any;
  get_latest_variable_code_block_id: Object;
  variable_code_job_types: any;
  app_routes: any;
  app_route_types: any;
  app_route_insert_types: any;
  system_log_type_data_sectors: any;


           // toggle elements
        //  isShow = true;
        isShow_chart1 = false;
        isShow_chart2 = false;

        isShow_chart1_meta = false;
        isShow_chart2_meta = false; // user investigation as default
        isShow_chart3_meta = false; // user investigation as default
        // log view variables.
        isShow_created_by = false;
        isShow_data = false;
        isShow_data_tools = false;
        isShow_help_content = true;
        isShow_all_items = false;



          // Text editor
  public myValue = 0;
  baseUploadURLDocxThemeTemplates: string;
  

  public insertImageSettings = {
    display: 'inline'
};

public mode: string = 'Markdown'; // Sets and removes for safe HTML/Sanitise etc  HTML | Markdown

@ViewChild('defaultRTE', {static: false}) defaultRTE;
@ViewChild('ejDialog', {static: false}) defaultDialog;
@ViewChild('ddlelement2', {static: false}) 
public countryObj: DropDownListComponent; 
public dropDownListObject: DropDownList
public editorManager: EditorManager; 
public proxy:any
public isParentDropdownChanged: boolean = false;
public rteObj: RichTextEditorComponent;

public dropdownVariables: DropDownList

public countryFields: Object = { text: 'CountryName', value: 'CountryId' };
client_fields: Object = { text: 'user_full_name', value: 'user_id' };
dateFormat: DateFormat;

initialPage: { pageSize: number; };
woo_products_object: any;
  doc_id: any;

  subject_template_doc: any;
  brand: any;
  placeHolderdata: string[] | DataManager | number[] | { [key: string]: Object; }[] | boolean[];
  dropdownVariablesOrderPickList: DropDownList;
  dropdownVariablesOrderSender: DropDownList;
  dropdownVariablesOrder: DropDownList;
  app_route: any;
  app_route_id: number;
  brand_id: any;
  bsModalRef: any;
  get_latest_app_route_id: Object;
  brand_types: any;
  users: any;
  usersPrimary: any;
  user_levels: any;
  projects: any;
  projects_data: any;
  // app_route_types: any;
  // app_route_insert_types: any;
  // app_routes: any;


  isShow_condition_array = false;
  isShow_condition_array_example = false;
  isShow_condition_array_keys_example = false;
  isShow_condition_array_fields = false;
  isShow_database = false;
  isShow_database_model_angular = false;
  isShow_database_mysql = false;
  app_route_chosen: Object;
  base_routes_parents_only: any;
  base_routes_parents_count_only: any;
  app_route_base_route_count: Object;
  app_route_base_route_LAST_FILE_NUMBER: number;
  app_route_base_route_child_count: Object;
  app_route_base_route_LAST_APP_ROUTE_NUMBER: number;
  app_route_task_route_child_count: Object;
  app_route_task_route_LAST_APP_ROUTE_CHILD_NUMBER: number;


  public opened() {
    this.defaultRTE.refreshUI();
  }
  
  // base product sample model based on Order ID 19348
  
  
  // my custom drop downs
  public height: any = '350px';
  
  
  public tools: object = {
    type: 'MultiRow',
        items: [ 
          'CreateTable',  '|' ,
          // {
          //   tooltipText: "PlaceHolder DropDown",        
          //   template:
          //     '<table><tr><td><input type="text" tabindex="1" id="ddlelement" /></td></tr></table>'
          // },
           '|',
        //   {
        //     tooltipText: 'Insert My Brand Variables',
        //     template: '<input type="text" id="dropdownVariables"/>'
        // },
        {
          tooltipText: 'Order Variables',
          template: '<input type="text" id="dropdownVariablesOrder" />'
      },
      {
        tooltipText: 'Order Sender',
        template: '<input type="text" id="dropdownVariablesOrderSender" />'
    },
      {
        tooltipText: 'Pick List Items',
        template: '<input type="text" id="dropdownVariablesOrderPickList" />'
    },
       '|',
      // {
      //   tooltipText: 'Insert/Upload Image',
      //   undo: true,
      //   click: this.onClickImageButton.bind(this),
      //   template: '<button type="button" class="btn btn-default"><i class="fa fa-photo"></i></button>'
      // },
      {
        tooltipText: 'Insert Promotion',
        undo: true,
        click: this.onClickPromotionButton.bind(this),
        template: '<button type="button" class="btn btn-default"><i class="fa fa-qrcode"></i></button>'
      },
       '|',      
    'Bold', 'Italic', 'Underline', 'StrikeThrough',
    'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
    'LowerCase', 'UpperCase', '|',
    'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
    'Outdent', 'Indent', '|',
    'CreateLink', '|', 'ClearFormat',
    'SourceCode', 'FullScreen', '|', 'Undo', 'Redo', '|', 
  
    ]
    };
  
  

  // Repalce
  public quickToolbarSettings: QuickToolbarSettingsModel = {
    image: [
         'Align', 'Caption', 'Remove', 'InsertLink', 'OpenImageLink', '-',
        'EditImageLink', 'RemoveImageLink', 'Display', 'AltText', 'Dimension'
    ],
    table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
};

public size = {
    width: '40px',
    items: [{ text: '8', value: '8pt' },
    { text: '10', value: '10pt' },
    { text: '12', value: '12pt' },
    { text: '14', value: '14pt' },
    { text: '42', value: '42pt' }]
};
public family = {
    width: '60px',
    items: [
    { text: 'Segoe UI', value: 'Segoe UI' },
    { text: 'Arial', value: 'Arial,Helvetica,sans-serif' },
    { text: 'Courier New', value: 'Courier New,Courier,monospace' },
    { text: 'Georgia', value: 'Georgia,serif' },
    { text: 'Impact', value: 'Impact,Charcoal,sans-serif' },
    { text: 'Calibri Light', value: 'CalibriLight' }]
};

public dataVariables: { [key: string]: Object }[] = [
  // { Id: '2', Name: 'FirstName' },
  // { Id: '2', Name: 'LastName' },
  // { Id: '3', Name: 'MiddleName' }

// :: Owner mergeOwnerData
{ Id: '', Category: 'Owner', Name: 'Owner Business Name', insertValue: '${owner_business_name}', description: '' },
{ Id: '', Category: 'Owner', Name: 'Owner Phone', insertValue: '${owner_phone}', description: '' },
{ Id: '', Category: 'Owner', Name: 'Owner Address 1', insertValue: '${owner_address_1}', description: '' },
{ Id: '', Category: 'Owner', Name: 'Owner Address 2', insertValue: '${owner_address_2}', description: '' },
{ Id: '', Category: 'Owner', Name: 'Owner Suburb', insertValue: '${owner_suburb}', description: '' },
{ Id: '', Category: 'Owner', Name: 'Owner State', insertValue: '${owner_state}', description: '' },
{ Id: '', Category: 'Owner', Name: 'Owner Postcode', insertValue: '${owner_postcode}', description: '' },
{ Id: '', Category: 'Owner', Name: 'Owner Country', insertValue: '${owner_country}', description: '' },
{ Id: '', Category: 'Owner', Name: 'Owner Type', insertValue: '${owner_brand_type_id}', description: '' },
];


public dataVariablesOrder: { [key: string]: Object }[] = [
// :: WordPress Order mergeOwnerData
{ Id: '', Category: 'Order', Name: 'OrderID', insertValue: '${order_id}', description: '' },
{ Id: '', Category: 'Order', Name: 'Order Company Output', insertValue: '${order_shipping_company_output}', description: '' },
{ Id: '', Category: 'Order', Name: 'Order Company', insertValue: '${order_shipping_company}', description: '' },
{ Id: '', Category: 'Order', Name: 'First Name Abrv.', insertValue: '${order_shipping_first_name_abr}', description: '' },
{ Id: '', Category: 'Order', Name: 'First Name', insertValue: '${order_shipping_first_name}', description: '' },
{ Id: '', Category: 'Order', Name: 'Surname', insertValue: '${order_shipping_first_name}', description: '' },

{ Id: '', Category: 'Order', Name: 'Address Line 1', insertValue: '${order_shipping_address_1}', description: '' },
{ Id: '', Category: 'Order', Name: 'Address Line 2', insertValue: '${order_shipping_address_2}', description: '' },
{ Id: '', Category: 'Order', Name: 'City', insertValue: '${order_shipping_city}', description: '' },
{ Id: '', Category: 'Order', Name: 'State', insertValue: '${order_shipping_state}', description: '' },
{ Id: '', Category: 'Order', Name: 'Postcode', insertValue: '${order_shipping_postcode}', description: '' },
{ Id: '', Category: 'Order', Name: 'Country Abrv.', insertValue: '${order_shipping_country}', description: '' },



{ Id: '', Category: 'Order', Name: 'Shipping Method', insertValue: '${shipping_data_method_title}', description: '' },
{ Id: '', Category: 'Order', Name: 'Shipping Total', insertValue: '${shipping_data_total}', description: '' },

{ Id: '', Category: 'Order', Name: 'Customm Postage Output', insertValue: '${owner_brand_type_id}', description: '' },
{ Id: '', Category: 'Order', Name: 'Order Items Table', insertValue: '${items}', description: '' },
{ Id: '', Category: 'Order', Name: 'Order Items Table Alternative', insertValue: '${items2}', description: '' },

{ Id: '', Category: 'Order', Name: 'Item Full - CodeOutPut', insertValue: '${item_full}', description: '' },
{ Id: '', Category: 'Order', Name: 'CurrentID', insertValue: '${id}', description: '' },

];



public dataVariablesOrderSender: { [key: string]: Object }[] = [
  // :: WordPress Order mergeOwnerData
  { Id: '', Category: 'Order', Name: 'Order From Company Output', insertValue: '${order_from_shipping_company_output}', description: '' },
  { Id: '', Category: 'Order', Name: 'Order From Company', insertValue: '${order_from_shipping_company}', description: '' },
  // { Id: '', Category: 'Order', Name: 'First Name Abrv.', insertValue: '${order_shipping_first_name_abr}', description: '' },
  // { Id: '', Category: 'Order', Name: 'First Name', insertValue: '${order_shipping_first_name}', description: '' },
  // { Id: '', Category: 'Order', Name: 'Surname', insertValue: '${order_shipping_first_name}', description: '' },
  
  { Id: '', Category: 'Order', Name: 'From Address Line 1', insertValue: '${order_from_shipping_address_1}', description: '' },
  { Id: '', Category: 'Order', Name: 'From Address Line 2', insertValue: '${order_from_shipping_address_2}', description: '' },
  { Id: '', Category: 'Order', Name: 'From City', insertValue: '${order_from_shipping_city}', description: '' },
  { Id: '', Category: 'Order', Name: 'From State', insertValue: '${order_from_shipping_state}', description: '' },
  { Id: '', Category: 'Order', Name: 'From Postcode', insertValue: '${order_from_shipping_postcode}', description: '' },
  { Id: '', Category: 'Order', Name: 'From Country Abrv.', insertValue: '${order_from_shipping_country}', description: '' },
  
  
  ];


  public dataVariablesOrderPickList: { [key: string]: Object }[] = [
    // :: WordPress Order mergeOwnerData
    { Id: '', Category: 'Order', Name: 'Pick List Title', insertValue: '${pick_list_title}', description: '' },
    { Id: '', Category: 'Order', Name: 'Today', insertValue: '${now_today}', description: '' },
    
    { Id: '', Category: 'Order', Name: 'Created - TimeStamp Words', insertValue: '${now_full_words}', description: '' },
    { Id: '', Category: 'Order', Name: 'Pick List Table Header', insertValue: '${pick_list_items_header}', description: '' },
    { Id: '', Category: 'Order', Name: 'Pick List Items (All) Table', insertValue: '${pick_list_items}', description: '' },
    { Id: '', Category: 'Order', Name: 'Pick List Items (Ebay) Table', insertValue: '${pick_list_ebay_items}', description: '' },
    { Id: '', Category: 'Order', Name: 'Pick List Items (WooCheckout) Table', insertValue: '${pick_list_checkout_items}', description: '' },
    { Id: '', Category: 'Order', Name: 'Pick List Key - Definition', insertValue: '${pick_list_key}', description: '' },

    ];

      // Text editor Settings
      public simpleToolBar: object = {
        type: 'Expand',
        enableFloating: false,
        items: ['Bold', 'Italic', 'Underline',
        'FontSize', 'FontColor', 'BackgroundColor',
        'LowerCase', 'UpperCase', '|',
        'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
        'Outdent', 'Indent', '|',
        'CreateLink', '|', 'ClearFormat', 'Print',
        'SourceCode', '|', 'Undo', 'Redo',
        // {
        //   tooltipText: 'Insert Promotion',
        //   undo: true,
        //   click: this.onClickPromotionButton.bind(this),
        //   template: '<button type="button" class="btn btn-default"><i class="fa fa-qrcode"></i></button>'
        // }
      ]
        };
        public pasteCleanupSettings: object = {
          prompt: true,
          plainText: false,
          keepFormat: false,
          deniedTags: ['a'],
          deniedAttrs: ['class', 'title', 'id'],
          allowedStyleProps: ['color', 'margin', 'font-size']
      };  


  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    private router: Router,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private modalService: BsModalService, viewRef: ViewContainerRef,
    public gfunc: GlobalFunctionsService
  ) { }

  ngOnInit() {

    this.model = new AppRoute();
    this.model.job_type_id = this.send_job_type_id;
    this.model.job_type_court_id = this.sent_job_type_court_id;

    // get the rules sql
    // this.getJobServiceTimeframeCountTypes();
    // this.getJobServiceTimeframeTimeTypes();
    // this.getJobServiceTimeframeTimeWhen();
    // this.getJobServiceTimeframeDateTypes();




    if(this.widget_size == 'create_base_route'){
      this.model.app_route_parent_id = this.item_data.app_route_id;
      this.model.app_route_type_id = '6';  // BASE ROUNTE MASTET
      this.model.app_route_insert_type_id = '8';
      this.model.app_guard = 'AdminGuard';
      this.model.brand_type_id = '1'; // TSA STAFF
      this.model.user_level_id = '1'; // webmaster
      this.model.log_type_data_sector_id = 9; // developer
      this.model.is_active =1;
      this.model.routerLink = this.item_data.routerLink;
      this.model.routerLinkGeneral = this.item_data.routerLinkGeneral;
      this.model.project_id = this.item_data.project_id;
      this.model.app_route_icon = 'fa fa-road';
      this.model.app_route_colour = '#000';
      this.model.guided_tour_content = this.item_data.guided_tour_content + 1;
      // this.calculateNewRouteNumbers(this.model);
      this.getProjectBaseRouteCount(this.model)  // Auto SIMEMAP Number

    }


    if(this.widget_size == 'create_base_child_route'){
      this.model.app_route_parent_id = this.item_data.app_route_id;
      this.model.app_route_type_id = '6';  // BASE ROUNTE MASTET
      this.model.app_route_insert_type_id ='8';
      this.model.app_guard = 'AdminGuard';
      this.model.brand_type_id = '1'; // TSA STAFF
      this.model.user_level_id = '1'; // webmaster
      this.model.log_type_data_sector_id = 9; // developer
      this.model.is_active =1;
      this.model.routerLink = this.item_data.routerLink;
      this.model.routerLinkGeneral = this.item_data.routerLinkGeneral;
      this.model.project_id = this.item_data.project_id;
      this.model.app_route_icon = 'fa fa-road';
      this.model.app_route_colour = '#000';
      this.model.guided_tour_content = this.item_data.guided_tour_content + 1;
      // this.calculateNewRouteNumbers(this.model);
      this.model.file_number = this.item_data.file_number; // needs to be established pruor to look and set
      this.getProjectBaseChildRouteCount(this.model)  // Auto SIMEMAP Number

    }







        // Set the defaults from teh compont below -- Child Route Task
        if(this.widget_size == 'create_child_task'){
          this.model.app_route_parent_id = this.item_data.app_route_id;
          this.model.app_route_type_id = 32;  //Item Task
          this.model.app_route_insert_type_id = 22;
          this.model.app_guard = 'AdminGuard';
          this.model.brand_type_id = '1'; // TSA STAFF
          this.model.user_level_id = '1'; // webmaster
          this.model.log_type_data_sector_id = 9; // developer
          this.model.is_active =1;
          this.model.routerLink = this.item_data.routerLink;
          this.model.routerLinkGeneral = this.item_data.routerLinkGeneral;
          this.model.project_id = this.item_data.project_id;
          this.model.app_route_icon = 'fa fa-flask';
          this.model.app_route_colour = this.item_data.app_route_colour;
          this.model.guided_tour_content = this.item_data.guided_tour_content + 1;

          this.model.file_number = this.item_data.file_number; // needs to be established pruor to look and set
          this.model.app_route_number = this.item_data.app_route_number; // needs to be established pruor to look and set
          this.getProjectTaskRouteChildCount(this.model)  // Auto SIMEMAP Number

        }




        this.getAppRoutes()

        this.getVariableCodeBlockTypes();
        this.getJobTypes();
        
        this.getUsers();
        this.getFormUserLevels();
        this.getBrandTypes();
    
    
    
        this.getAppRouteTypes()
        this.getAppRouteInsertTypes();
         this.getSystemLogTypeDataSectors();
    
         this.getProjects()
        


    

  }



calculateNewRouteNumbers(model){

  if(model.app_route_type_id == 6 || model.app_route_type_id == 10){
    // Creating File Number (Base of Quote Route)
    // lookup all routes with or these types // count and add one ==
    
    this.countBaseRoutesParentsOnly();
    this.model.file_number = this.base_routes_parents_count_only + 1;
  }



  if(model.app_route_type_id == 32 ){
    // Creating File Number (Base of Quote Route)
    // lookup all routes with or these types // count and add one ==
    
    this.countBaseRoutesParentsOnly();
    this.model.file_number = this.base_routes_parents_count_only + 1;
  }


// First check if already exist - And only update if not already existing...
// What is my default order...?? ID desc  file number, then by , app_route_number, then by, app_route_child_number


// Base. - No Parents nor Children
 // Rule Base As Child: If App Type is "Quote Item || Base Route" - File Number Counts and new file number and add 1 -- everything else nulls


  // Rule Base As Child: If App Type is "Quote Item || Base Route" - File Number Counts and new file number and add 1
      //  if this has parent > 1 new :: app_route_number = count children of route + 1 --- keep the above



 // Rule As A child Route of a (base route or quote )
 //leave file_number
 // count all children and add to app_route_number + 1     

}


countBaseRoutesParentsOnly(){
  this.search_model = {
    // "routerLink": this.current_route,
    // "routerLinkGeneral": this.current_route, // added to show other artivles that are general
    // "is_active": 1,
    // "user_level_id": this.gfunc.sessionUserLevel,
    "app_route_type_id": 6, // tips only
  
    // Filter the information that a general route is one with no router link as the primary.... or spil in UI??? TO....
  }// set to empty to get all first.
  
  
      this._demoService.getAppRoutesSearchFull(this.search_model).subscribe(
        data => {
          //  this.app_routes_metrix_search_related = data;
         let res = data[0];
          // pass so that the dates are correct in Sync
          // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
         
         
          this.base_routes_parents_only = DataUtil.parse.parseJson(data);
          this.base_routes_parents_count_only = this.base_routes_parents_only.length
          // this.subject_service_metrix_search_full_results = data;
          // this.new_data_related = this.app_routes_metrix_search_related_results.slice(0, 500);
          // this.app_route_related = this.new_data_related; // sets the data
          

        // this.toastr.info(this.base_routes_parents_count_only)
  
        //  this.grid.refresh();
      
          },
          error => {
          console.error('Error Loading !' + error.error);
        this.toastr.error('error getting numbers')

          console.log(error);
          // return Observable.throw(error);
          }
          );






}






// LookUP ALL BASE ROUTES/Quote Routes -- Order By file_number desc -- of a particular project
getProjectBaseRouteCount(model) {
  this._demoService.getProjectBaseRouteCount(model).subscribe(
      data => { 
        this.app_route_base_route_count = data;         
        let res = data[0]

        if(!res){
          // Usually means no route exists so we need to set as 0 and add one.
           if(this.app_route_base_route_LAST_FILE_NUMBER <= 0 || this.app_route_base_route_LAST_FILE_NUMBER == null){
          // SET THE NEW CHILD -- First
          this.app_route_base_route_LAST_FILE_NUMBER = 0;
        }

        }else{
          // do calculations.
          this.app_route_base_route_LAST_FILE_NUMBER =  res.file_number as number;
          this.toastr.info('Last File Number: ' + this.app_route_base_route_LAST_FILE_NUMBER);    

        }


    
      // Set the model and form value 
      // this.model.file_number = (this.app_route_base_route_LAST_FILE_NUMBER + 1); //
      this.model.file_number = this.getSumAny(1, this.app_route_base_route_LAST_FILE_NUMBER); //
      this.model.app_route_number = 0 //
      this.model.app_route_child_number = 0; //

      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }



  getProjectBaseChildRouteCount(model) {

    /// Leave File Number and get New app_route_number

    this._demoService.getProjectBaseRouteChildCount(model).subscribe(
        data => { 
          this.app_route_base_route_child_count = data;         
          let res = data[0]
  


          if(!res){
            // Usually means no route exists so we need to set as 0 and add one.
             if(this.app_route_base_route_LAST_APP_ROUTE_NUMBER <= 0 || this.app_route_base_route_LAST_APP_ROUTE_NUMBER == null){
            // SET THE NEW CHILD -- First
            this.app_route_base_route_LAST_APP_ROUTE_NUMBER = 0;
          }

          }else{
            // do calculations.
            this.app_route_base_route_LAST_APP_ROUTE_NUMBER =  res.app_route_number as number;
            this.toastr.info('Last Child: app Route Number: ' + this.app_route_base_route_LAST_APP_ROUTE_NUMBER);

          }


        // Set the model and form value 
        // this.model.file_number = (this.app_route_base_route_LAST_FILE_NUMBER + 1); //
        // this.model.file_number = this.getSumAny(1, this.app_route_base_route_LAST_FILE_NUMBER); //
        this.model.file_number = this.item_data.file_number; // leave
        this.model.app_route_number = this.getSumAny(1, this.app_route_base_route_LAST_APP_ROUTE_NUMBER); // do calculations all with the same app_route_number + 1
        this.model.app_route_child_number = 0; // set as zero
  
        },
        err => console.error(err),
        // () => console.log('done loading Trace Types')
      );
    }
  





      // Counts for TASK_ITEMS children only for app_route_child_numbering.
    getProjectTaskRouteChildCount(model) {

      /// Leave File Number and leave app_route_number and get New app_route_child_number
  
      this._demoService.getProjectTaskRouteChildCount(model).subscribe(
          data => { 
            this.app_route_task_route_child_count = data;         
            let res = data[0]
    
            if(!res){
              // Usually means no route exists so we need to set as 0 and add one.
               if(this.app_route_task_route_LAST_APP_ROUTE_CHILD_NUMBER <= 0 || this.app_route_task_route_LAST_APP_ROUTE_CHILD_NUMBER == null){
              // SET THE NEW CHILD -- First
              this.app_route_task_route_LAST_APP_ROUTE_CHILD_NUMBER = 0;
            }

            }else{
              // do calculations.
              this.app_route_task_route_LAST_APP_ROUTE_CHILD_NUMBER =  res.app_route_child_number as number;
              this.toastr.info('TASK Last Child: app Route CHILD Number: ' + this.app_route_task_route_LAST_APP_ROUTE_CHILD_NUMBER);
  
            }

                        
              // Set the model and form value 
              // this.model.file_number = (this.app_route_base_route_LAST_FILE_NUMBER + 1); //
              // this.model.file_number = this.getSumAny(1, this.app_route_base_route_LAST_FILE_NUMBER); //
              this.model.file_number = this.item_data.file_number; // leave
              this.model.app_route_number =  this.item_data.app_route_number; // do calculations all with the same app_route_number + 1
              this.model.app_route_child_number = this.getSumAny(1, this.app_route_task_route_LAST_APP_ROUTE_CHILD_NUMBER); // set as zero
   
    
          },
          err => console.error(err),
          () => {
            // IF THERE IS ERROR or no return means there is no route so create the first one.
            // if(this.app_route_task_route_LAST_APP_ROUTE_CHILD_NUMBER <= 0 || this.app_route_task_route_LAST_APP_ROUTE_CHILD_NUMBER == null){
            //   // SET THE NEW CHILD -- First
            //   this.app_route_task_route_LAST_APP_ROUTE_CHILD_NUMBER = 1;
            // }
            console.log('done calculations')
          }
        );
      }










  // Sum of two different types of variables... -- Use this when variables do no add up corretly and just append the numbers together.
  // :: @https://www.codevscolor.com/typescript-add-two-numbers
  getSumAny(first: number | string, second: number | string) {
    if (typeof first === "string") {
      first = Number(first);
    }
    if (typeof second === "string") {
      second = Number(second);
    }
  
    return first + second;
  }

getAppRouteTypes() {
    this._demoService.getAppRouteTypes().subscribe(
        data => { this.app_route_types = data; },
        err => console.error(err),
        // () => console.log('done loading Trace Types')
      );
    }


    getAppRouteInsertTypes() {
      this._demoService.getAppRouteInsertTypes().subscribe(
          data => { this.app_route_insert_types = data; },
          err => console.error(err),
          // () => console.log('done loading Trace Types')
        );
      }

      getSystemLogTypeDataSectors() {
        this._demoService.getSystemLogTypeDataSectors().subscribe(
           data => { this.system_log_type_data_sectors = data;
          
          },
           err => console.error(err),
           () => console.log('System Log Type')
         );
       }
      
       createAppRoute(model) {
        // console.log(model);
        // this.model.updated_by = this.gfunc.sessionUserId;
        this.model.created_by = this.gfunc.sessionUserId;
          this._demoService.createAppRoute(model).subscribe(
                data => {  this.get_latest_app_route_id = data; // this is the retuned json upon creation.
      
                  this.traceAddNotice ();
        /*
                // tslint:disable-next-line:max-line-length
                this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
                this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
        */
                this.closeParentModel.emit();
              //   CreateJobTypeComponent.returned.next(false);
                  //  return true;
                },
                error => {
                  this.toastr.error('Adding App Route Failed :: Please try again!');
                  // console.log(Observable.throw(error));
                  // return Observable.throw(error);
                console.error(error);
                }
          );
          }


  createVariableCodeBlock(model) {
  // console.log(model);
    this._demoService.createVariableCodeBlock(model).subscribe(
          data => {  this.get_latest_variable_code_block_id = data; // this is the retuned json upon creation.

            this.traceAddNotice ();
  /*
          // tslint:disable-next-line:max-line-length
          this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
          this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
  */
          this.closeParentModel.emit();
        //   CreateJobTypeComponent.returned.next(false);
            //  return true;
          },
          error => {
            this.toastr.error('Adding Block Failed :: Please try again!');
            // console.log(Observable.throw(error));
            // return Observable.throw(error);
          console.error(error);
          }
    );
    }

    getVariableCodeBlockTypes() {
    this._demoService.getVariableCodeBlockTypes().subscribe(
        data => { this.variable_code_job_types = data; },
        err => console.error(err),
        // () => console.log('done loading Trace Types')
      );
    }

  getJobTypes() {
    this._demoService.getJobTypes().subscribe(
       data => { this.job_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   getJobTypeLocations(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
       data => { this.job_type_locations = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  

   sendJobTypeLocationsID(job_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count2 = job_type_id;
    this.getJobTypeLocations(this.count2); // updates the selected job ID....
    this.model.job_type_location_id = 1;
    this.model.job_type_court_id = 0;
    // this.model.job_type_document_type_id = 0;
    // this.model.job_type_affidavit_type_id = 0;

  }



  getJobServiceTimeframeCountTypes() {
    this._demoService.getJobServiceTimeframeCountTypes().subscribe(
       data => { this.job_service_timeframe_count_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   getJobServiceTimeframeTimeTypes() {
    this._demoService.getJobServiceTimeframeTimeTypes().subscribe(
       data => { this.job_service_timeframe_time_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getJobServiceTimeframeTimeWhen() {
    this._demoService.getJobServiceTimeframeTimeWhen().subscribe(
       data => { this.job_service_timeframe_time_when = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   getJobServiceTimeframeDateTypes() {
    this._demoService.getJobServiceTimeframeDateTypes().subscribe(
       data => { this.job_service_timeframe_date_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


  createJobServiceTimeframe(model) {
    // console.log(model);
        this._demoService.createJobServiceTimeframe(model).subscribe(
             data => {  this.get_latest_service_timeframe_id = data; // this is the retuned json upon creation.
     
               this.traceAddNotice ();
     /*
             // tslint:disable-next-line:max-line-length
             this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
             this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
     */
             this.closeParentModel.emit();
           //   CreateJobTypeComponent.returned.next(false);
               //  return true;
             },
             error => {
               this.toastr.error('Adding Service Timeframe Failed :: Please try again!');
               // console.log(Observable.throw(error));
               // return Observable.throw(error);
              console.error(error);
             }
        );
        }





  createJobServiceRule(model) {
    // console.log(model);
        this._demoService.createJobServiceRule(model).subscribe(
             data => {  this.get_latest_service_rule_id = data; // this is the retuned json upon creation.
     
               this.traceAddNotice ();
     /*
             // tslint:disable-next-line:max-line-length
             this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
             this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
     */
             this.closeParentModel.emit();
           //   CreateJobTypeComponent.returned.next(false);
               //  return true;
             },
             error => {
               this.toastr.error('Adding Service Rule Failed :: Please try again!');
               // console.log(Observable.throw(error));
               // return Observable.throw(error);
              console.error(error);
             }
        );
        }


  createJobTypeAffidavit(model) {
    // console.log(model);
        this._demoService.createJobTypeAffidavit(model).subscribe(
             data => {  this.get_latest_affidavit_id = data; // this is the retuned json upon creation.
     
               this.traceAddNotice ();
     /*
             // tslint:disable-next-line:max-line-length
             this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
             this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
     */
             this.closeParentModel.emit();
           //   CreateJobTypeComponent.returned.next(false);
               //  return true;
             },
             error => {
               this.toastr.error('Adding Affidavit Failed :: Please try again!');
               // console.log(Observable.throw(error));
               // return Observable.throw(error);
             }
        );
        }
 
 
        traceAddNotice () {
         this.toastr.info('Success... Added');
       };
 



       getJobTypeCourts(job_type_location_id) {
        this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
           data => { this.job_type_courts = data; },
           err => console.error(err),
           // () => console.log('done loading Trace Types')
         );
       }
      
      
       sendJobTypeCourtsID(job_type_location_id) {
        // this.initialCount = this.trace_candidates.trace_candidate_id;
        this.sent_job_type_location_id = job_type_location_id;
        this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....
      
      }


      getJobTypeDocumentTypes(job_type_court_id) {
        this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
           data => { this.job_type_document_types = data; },
           err => console.error(err),
           // () => console.log('done loading Trace Types')
         );
       }
      
      
       sendJobTypeDocumentTypesID(job_type_court_id) {
        // this.initialCount = this.trace_candidates.trace_candidate_id;
        this.sent_job_type_court_id = job_type_court_id;
        this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....
    
      }


      getAppRoutes() {
        this._demoService.getAppRoutes().subscribe(
           data => { this.app_routes = data;
          
          },
           err => console.error(err),
           () => console.log('System Log Type')
         );
       }


       getAppRoute(app_route_id) {
        this._demoService.getAppRoute(app_route_id).subscribe(
           data => { this.app_route_chosen = data;
          
            // Get the Last router Number.
            // router_number
            // router_child number
            // app_route_parent_array
          },
           err => console.error(err),
           () => console.log('System Log Type')
         );
       }



       getBrandTypes() {
        this._demoService.getBrandBrandTypes().subscribe(
           data => { this.brand_types = data; },
           err => console.error(err),
           // () => console.log('done loading candidate for update')
         );
       }
  
  
  
       getUsers() {
        this._demoService.getUsers().subscribe(
          data => { this.users = data;
            this.usersPrimary = data;
           let res = data[0];
         },
          err => console.error(err),
          // () => console.log('done loading Trace Types')
        );
      }
      
  

      getFormUserLevels() {
        this._demoService.getUserLevels().subscribe(
           data2 => { this.user_levels = data2;
            console.log(data2);
         },
           err => console.error(err),
           () => console.log('done loading User Levels')
         );
       }
    




    
       public onClickPromotionButton() {
        // this.rteObj.focusIn();
        this.openModalWithComponent_Promotion();
    }
    
    
       // MODAL view a component
       openModalWithComponent_Promotion() {
      //   const initialState = {
      //     title: 'Select Promotion Item(s) - Choose for Templates',
      //     item_id: 1010,
      //     brand_id: this.brand_id,
      //     promotion_id: this.promotion_id,
      //     template_model: this.subject_template_doc,
      //     size: 'lg',
      //     backdrop: true,
      //     IgnoreBackdropClick: false,
      //   };
      //   this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      //   // sets the var to in the component model
      //   this.bsModalRef.content.brand_id = this.brand_id;
      //   this.bsModalRef.content.item_id = this.brand_id;
      //   this.bsModalRef.content.closeBtnName = 'Close';
      //   this.bsModalRef.content.brand_model = this.brand;
      //   this.bsModalRef.content.promotion_id = this.promotion_id;
      //   this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      //   // subscribed to the emitter and get the value.
      //             //   this.bsModalRef.content.action.take(1).subscribe((value) => {
      //             // // console.log(value); // here you will get the value of the file
      //             // // Remove the "uploads/" part from the filename.
      //             // this.filenameselected = value;
      //             // this.stripped = this.filenameselected.replace('uploads/', '');
      //             // // this.model.main_image = this.stripped; // works for simple add not update.
      //             // // console.log(this.stripped);
      //             // // console.log(this.model);
      //             // this.form.logo = this.stripped;
      //             // // this.form.reset();
      //             // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
      //             // this.form.controls['logo'].patchValue(this.form.logo);
                  
      //             // });
      //             // modal component method clickOK to run local method addFileNameFromModal
      //             // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
              
      //             // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
    
      //             this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
      //             this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
      //             this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
      //             this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
      //             this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
    
                  
      //             // Try wrapping an image tag around the image before inserting.
      //             // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
    
      //             // return this.modalRef.content.onClose;
    
      }




		// :: Parent / Child modal test
		public addFileNameFromModal_ET(filename) {
		  // alert('Clicked');
		  this.form.controls['email_template'].patchValue(filename); // works by setting the new frorm value from parent modal.
      // has to be correct form name
		// this.modalRef.hide();
		// console.log('Added External Recipeint.');
		// this.toastr.info('External Recipient Added');
		};


    public onClickImageButton() {
      // this.rteObj.focusIn();
      // this.openModalWithComponent_Brand();
  }
  
    public onCreate(): void { 
      let data: { [key: string]: Object }[] = [
          { Id: '2', Name: 'FirstName' },
          { Id: '2', Name: 'LastName' },
          { Id: '3', Name: 'MiddleName' }
      ];
      let proxy = this.rteObj;
       let dropdownVariables: DropDownList = new DropDownList({
          dataSource: data,
          fields: { text: 'Name' },
          placeholder: 'Insert Fields',
          width: '100px',
          change: (args: any)=>{
            proxy.focusIn();
            InsertHtml.Insert(document, document.createTextNode(args.value));
          }
      });
      dropdownVariables.appendTo('#dropdownVariables');
      
      
      } 
  
      public onCreate2(): void { 
        this.proxy = this.defaultRTE;
        // initialize Custom DropDownList component
         this.dropdownVariables = new DropDownList({
          dataSource: this.dataVariables,
          fields: { text: 'Name', value: 'insertValue' },
          // fields: { text: 'Name' },
          placeholder: 'My Details',
          width: '300px',
          change: (args: any)=>{
            this.defaultRTE.focusIn();
            InsertHtml.Insert(document, document.createTextNode(args.value));
          }
        });
        this.dropdownVariables.appendTo('#dropdownVariables');
  
  
        this.dropdownVariablesOrder = new DropDownList({
          dataSource: this.dataVariablesOrder,
          fields: { text: 'Name', value: 'insertValue' },
          // fields: { text: 'Name' },
          placeholder: 'Order Variables',
          width: '300px',
          change: (args: any)=>{
            this.defaultRTE.focusIn();
            InsertHtml.Insert(document, document.createTextNode(args.value));
          }
        });
        this.dropdownVariablesOrder.appendTo('#dropdownVariablesOrder');
  
        this.dropdownVariablesOrderSender = new DropDownList({
          dataSource: this.dataVariablesOrderSender,
          fields: { text: 'Name', value: 'insertValue' },
          // fields: { text: 'Name' },
          placeholder: 'Order Sender',
          width: '300px',
          change: (args: any)=>{
            this.defaultRTE.focusIn();
            InsertHtml.Insert(document, document.createTextNode(args.value));
          }
        });
        this.dropdownVariablesOrderSender.appendTo('#dropdownVariablesOrderSender');
  
  
        this.dropdownVariablesOrderPickList = new DropDownList({
          dataSource: this.dataVariablesOrderPickList,
          fields: { text: 'Name', value: 'insertValue' },
          // fields: { text: 'Name' },
          placeholder: 'Pick List Items',
          width: '300px',
          change: (args: any)=>{
            this.defaultRTE.focusIn();
            InsertHtml.Insert(document, document.createTextNode(args.value));
          }
        });
        this.dropdownVariablesOrderPickList.appendTo('#dropdownVariablesOrderPickList');
  
  
  
  
      }
  
  
        // drop down function
        onChangeVariables(args): void {
        //  let element: HTMLElement = document.createElement('p');
        if (args.isInteracted) {
        //  element.innerText = 'Changes happened by Interaction';
        // this.container.documentEditor.editor.insertText(args.value); // works for workd editor
        this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
        InsertHtml.Insert(document, document.createTextNode(args.value));
        this.toastr.info('Variable Added at cursor position within Template');
        // hide the modal
       // this.modalRef.hide();
        } else {
        // element.innerText = 'Changes happened by programmatic';
        }
  
        // document.getElementById('event').append(element);
        };
  
  
  
  
  
  
  
  
    oncreated() {
      this.proxy = this;  
      // initialize Custom DropDownList component
       this.dropDownListObject = new DropDownList({
          placeholder: "Select PlaceHolder Value",
          width: "180px",
          fields: { text: 'StateName', value: "SateId" },
          // change: (args: any)=>{
          //   this.defaultRTE.focusIn();
          //   InsertHtml.Insert(document, document.createTextNode(args.value));
          // }
          change: this.OnChanged.bind(this),
          //set the data to dataSource property
          dataSource: this.placeHolderdata
      });
      this.dropDownListObject.appendTo('#ddlelement');
    }
    //Parent dropdown change event
  
        //pass the filter data source, filter query to updateData method.
    public countryChange(): void {
      let predicate = new Predicate('CountryId', 'equal', this.countryObj.value, true);
      predicate = predicate.or('CountryId', 'equal','0' ,true);
      let query: Query = new Query();
        //frame the query based on search string with filter type.
        query = query.where(predicate);
      // let tempQuery: Query = new Query().where('CountryId', 'equal', this.countryObj.value); // commented out in example
      //     this.dropDownListObject.query = tempQuery;
          this.dropDownListObject.query = query;
            this.dropDownListObject.text = null;
              this.dropDownListObject.dataBind();
              this.isParentDropdownChanged = true;
              
    }
    OnChanged(args) { 
      //Change the Rich Text Editor placeholder
      // this.defaultRTE.placeholder = args.value;
      this.defaultRTE.focusIn();
      InsertHtml.Insert(document, document.createTextNode(args.value));
  
    }
    clicked() {
      this.defaultDialog.show();
    }
  

    getProjects() {
      this._demoService.getProjects().subscribe(
        data => {
          this.projects = data;
          let res = data[0]
          // pass so that the dates are correct in Sync
          // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
          this.projects_data = DataUtil.parse.parseJson(data);
  
  // :: TO A loop of details below.

  

  
        },
        error => {
          //  console.error('Error Loading User!');
          // return Observable.throw(error);
        }
      );
    }


    setColour(value2){
      console.log('SetColour: ' + value2)
      this.brandForm.app_route_colour.value = this.brandForm.colourpicker.value
    }
    


}

